import { type Locale } from '@aps/contracts';

/*
 * Pul formatlash KONTRAKTGA ko'chirildi: uni bot ham ishlatadi va u
 * React'siz Node ilovasi. Bu yerdan qayta eksport qilinadi — ekranlar
 * o'zgarishsiz `@aps/ui` dan olishda davom etadi.
 *
 * Import ALOHIDA YO'LDAN (`/money-format`), umumiy barrel'dan emas:
 * barrel butun kontraktni — barcha zod schemalarini — tortib keladi va
 * Mini App bandli 21 KB ga o'sib ketgan edi (o'lchangan).
 */
export {
  formatMoney,
  formatMoneyValue,
  formatSumInput,
  moneyUnit,
  parseSumInput,
} from '@aps/contracts/money-format';

/**
 * Ko'rsatish uchun formatlash.
 *
 * Pul UI qatlamida FAQAT shu funksiya orqali formatlanadi. Komponent
 * ichida `toLocaleString` yozilmaydi — aks holda bir ekranda "385 000",
 * boshqasida "385,000" chiqadi (avtopart-money skill).
 */

/**
 * Chegirma foizi — butun songa yaxlitlangan.
 *
 * Ko'rsatish uchun; hisob-kitobda ishlatilmaydi (avtopart-money skill:
 * hisob BigInt va basis point bilan).
 */
export function discountPercent(price: string, oldPrice: string | null): number | null {
  if (oldPrice === null) return null;
  const now = /^-?\d+$/.test(price) ? BigInt(price) : null;
  const before = /^-?\d+$/.test(oldPrice) ? BigInt(oldPrice) : null;
  if (now === null || before === null || before <= now || before <= 0n) return null;

  // Butun foiz: (before - now) * 100 / before
  return Number(((before - now) * 100n) / before);
}

/**
 * Ikki tilli maydonni tanlaydi.
 *
 * `*Ru` bo'sh bo'lsa `*Uz` ko'rsatiladi — HECH QACHON bo'sh joy emas
 * (docs/03-UI-UX.md → "Matn qoidalari").
 */
export function pickText(uz: string, ru: string | null | undefined, locale: Locale): string {
  if (locale === 'RU') {
    const trimmed = ru?.trim();
    if (trimmed !== undefined && trimmed !== '') return trimmed;
  }
  return uz;
}

/** Sana — mijozga tushunarli ko'rinishda. */
export function formatDate(iso: string | null | undefined, _locale: Locale): string {
  if (iso === null || iso === undefined) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';

  /*
   * `Intl` ISHLATILMAYDI va bu o'lchangan qaror.
   *
   * `Intl.DateTimeFormat('uz-UZ', ...)` muhitning ICU ma'lumotiga
   * bog'liq va BIR XIL kod turli joyda turlicha chiqaradi:
   *   Node 22 (WSL)          -> 17/09/2026
   *   Chromium (konteyner)   -> 2026-09-17
   * Ikkinchisi mijozga baza yozuvidek ko'rinadi, birinchisi esa
   * O'zbekistonda kutilgan shakl emas. Vizual darvoza ham shu sababdan
   * muhitga qarab qaltirardi.
   *
   * `dd.MM.yyyy` — demo ham, ruscha interfeys ham shu shaklda, ya'ni
   * ikkala til uchun bitta format yetarli (`locale` shuning uchun
   * ishlatilmaydi, lekin imzoda QOLADI: chaqiruvchilar o'zgarmaydi va
   * kelajakda til bo'yicha farq kerak bo'lsa joyi tayyor).
   */
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${day}.${month}.${String(date.getFullYear())}`;
}

/**
 * Sana va vaqt: "15.09.2026 14:30".
 *
 * Audit jurnali va tarix uchun — u yerda "qachon" savoli soatgacha
 * aniqlik talab qiladi. Sana qismi `formatDate` bilan bir xil manbadan,
 * shuning uchun ular hech qachon ajralib ketmaydi.
 */
export function formatDateTime(iso: string | null | undefined, locale: Locale): string {
  if (iso === null || iso === undefined) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${formatDate(iso, locale)} ${hours}:${minutes}`;
}

/** ETA oynasi: "15.09.2026 – 17.09.2026" yoki bitta sana. */
export function formatEtaRange(
  from: string | null | undefined,
  to: string | null | undefined,
  locale: Locale,
): string {
  const start = formatDate(from, locale);
  const end = formatDate(to, locale);
  if (start === '') return '';
  if (end === '' || end === start) return start;
  return `${start} – ${end}`;
}

/** Klass nomlarini birlashtiradi — `undefined` va `false` tashlanadi. */
export function cx(...values: (string | false | null | undefined)[]): string {
  return values
    .filter((value): value is string => typeof value === 'string' && value !== '')
    .join(' ');
}
